import { render, staticRenderFns } from "./TaskList.vue?vue&type=template&id=155600ee&scoped=true"
import script from "./TaskList.vue?vue&type=script&lang=js"
export * from "./TaskList.vue?vue&type=script&lang=js"
import style0 from "./TaskList.vue?vue&type=style&index=0&id=155600ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155600ee",
  null
  
)

export default component.exports